import { useEffect, useState } from "react";
import { hoyChile } from "../utils/fechaChile";

/**
 * Hoy en hora chilena (`YYYY-MM-DD`), actualizado solo cuando cambia el día.
 *
 * Si «hoy» se calcula una sola vez al montar, una página que queda abierta
 * pasada la medianoche sigue marcando el día anterior. Pasaba con el calendario
 * del admin. Por eso se revisa cada minuto y también al volver a la pestaña,
 * porque el navegador frena los timers de las pestañas en segundo plano.
 * Mientras el día no cambia, React no vuelve a renderizar (mismo string).
 */
export function useHoyChile(intervaloMs = 60_000): string {
  const [hoy, setHoy] = useState(hoyChile);

  useEffect(() => {
    const revisar = () => setHoy(hoyChile());
    const id = setInterval(revisar, intervaloMs);
    document.addEventListener("visibilitychange", revisar);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", revisar);
    };
  }, [intervaloMs]);

  return hoy;
}
